import { Typography, Box } from '@mui/material';
import React, { ReactNode } from 'react';

interface PageHeaderProps {
  title: string;
  extras?: ReactNode;
}

export const PageHeader: React.FC<PageHeaderProps> = ({ title, extras }) => {
  return (
    <Box sx={{ py: 4 }}>
      <Box
        sx={{
          alignItems: 'center',
          display: 'flex',
        }}>
        <Typography color="textPrimary" variant="h4">
          {title}
        </Typography>
        <Box sx={{ flexGrow: 1 }} />
        {extras}
      </Box>
    </Box>
  );
};
